

































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import GoodsApi from '@/api/goods/list'
import BrandApi from '@/api/goods/brand/index'
import MatchPicturesModal from './matchPicturesModal/index.vue'
import SyncProductModal from './syncProductModal/index.vue'
import BatchEditModal from '../batchEdit/index.vue'
import BatchShelfModal from '../batchShelf/index.vue'
import { Button } from '../../../types/iview/button'
import appconst from '@/lib/appconst'
@Component({
  components: {
    CustomForm,
    MatchPicturesModal,
    SyncProductModal,
    BatchEditModal,
    BatchShelfModal,
  },
})
export default class GoodsList extends AbpBase {
  matchPicturesModal = false
  syncProductModal = false
  batchEditProductModal = false
  batchShelfmodal = false
  templateUrl = ''
  uploadUrl = ''
  templateTagUrl = ''
  uploadTagUrl = ''
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '商品名称/商品货号',
      },
      key: 'keyWord',
    },
    {
      label: '商品分类：',
      type: 'select',
      key: 'categoryId',
      props: {
        placeholder: '请选择',
        filterable: true
      },
      options: [],
    },
    // {
    //   label: '品牌：',
    //   type: 'select',
    //   key: 'brandId',
    //   props: {
    //     placeholder: '请选择',
    //   },
    //   options: [],
    // },
    {
      label: '是否上架：',
      type: 'select',
      key: 'isTop',
      props: {
        placeholder: '请选择',
      },
      options: [
        {
          value: 1,
          text: '是',
        },
        {
          value: 0,
          text: '否',
        },
      ],
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '款号',
      key: 'code',
      align: 'center',
      sortable: true
    },
    // {
    //   title: '商品标签',
    //   key: 'productTagMappings',
    //   align: 'center',
    // },
    {
      title: '商品图',
      width: 100,
      slot: 'pictureUrl',
      align: 'center',
    },
    {
      title: '商品名称',
      slot: 'name',
      align: 'center',
    },
    {
      title: '零售价',
      slot: 'marketPrice',
      align: 'center',
    },
    {
      title: '订货价',
      slot: 'price',
      align: 'center',
    },
    {
      title: '箱规',
      key: 'productBoxRule',
      align: 'center',
    },
    // {
    //   title: '所属分类',
    //   slot: 'categories',
    //   align: 'center',
    // },
    {
      title: '部类',
      key: 'partCategory',
      align: 'center',
    },
    {
      title: '大类',
      key: 'bigCategory',
      align: 'center',
    },
    {
      title: '主题',
      key: 'themeCategory',
      align: 'center',
    },
    {
      title: '组别',
      key: 'groupCategory',
      align: 'center',
    },
    {
      title: '季节',
      key: 'seasonCategory',
      align: 'center',
    },
    {
      title: '库存',
      width: 80,
      align: 'center',
      key: 'totalStockQuantity',
    },
    {
      title: '下架/上架',
      slot: 'published',
      width: 100,
      align: 'center',
    },
    // {
    //   title: '是否置顶',
    //   slot: 'isTop',
    //   width: 100,
    //   align: 'center',
    // },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center',
    },
  ]
  isCheckAll: boolean = false
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  tabList = ['全部', '已上架', '未上架']
  activeTab = 0
  selectedIds: any = []
  tagList: any = []
  sorting: string = 'creationTime desc'

  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  async mounted() {
    this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/batchEdit/stateFile`
    this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/batchEdit/excel/stateUpload`
    this.templateTagUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/products/ProductsTagsTemplateFile`
    this.uploadTagUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/products/ImportProductsTagsFile`
    this.getCategoriesAll()
    this.getBrands()
    await this.getGoodTag()
    this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  onchange() {
    this.submitFn()
  }
  getTableData(form = {}) {
    this.isCheckAll = false
    let keyWord = form['keyWord']
    let categoryId = form['categoryId']
    let brandId = form['brandId']
    let isTop = form['isTop'] == 1 ? true : form['isTop'] == 0 ? false : null
    let { pageSize, currentPage, activeTab } = this
    let published = activeTab == 0 ? null : activeTab == 1 ? true : false
    GoodsApi.getList(pageSize, currentPage, keyWord, categoryId, published, brandId, isTop, this.sorting)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        res.data.items.forEach((parent) => {
          let temp = [];
          this.tagList.forEach((item) => {
            parent.productTagMappings.forEach((subItem) => {
              if (item.id == subItem.productTagId) {
                temp.push(item.name);
              }
            });
          });
          parent.productTagMappings = temp.join('、');
        });
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.filters.some((item) => {
          if (item.label == '商品分类：') {
            item.options = res.data.items.map((child) => {
              return {
                value: child.id,
                text: child.fullName,
              }
            })
            return true
          }
        })
      }
    })
  }
  /**
   * 获取商品品牌
   */
  getBrands() {
    BrandApi.getAll().then((res) => {
      if (res.data.items) {
        this.filters.some((item) => {
          if (item.label == '品牌：') {
            item.options = res.data.items.map((child) => {
              return {
                value: child.id,
                text: child.name,
              }
            })
            return true
          }
        })
      }
    })
  }
  getProductSalesAttributeValues(arr: any[]) {
    return arr.map((item) => item.name).join('，')
  }

  /**
   * 更改上架状态
   */
  publishedChange(row) {
    let ids: any = [row.id]
    GoodsApi.updatePublished(ids, row.published).then((res) => {
      this.submitFn()
    })
  }
  /**
   * 下载模板
   */
  downloadTemplate() {
    location.href = this.templateUrl
  }
  /**
   * 下载标签模板
   */
  downloadTagTemplate() {
    location.href = this.templateTagUrl
  }
  /**
   * 导入会员备注
   */
  uploadSuccess(res) {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    this.getTableData()
  }
  /**
   * 更改商品置顶
   */
  isTopChange(row) {
    let ids: any = [row.id]
    GoodsApi.updateIsTop(ids, row.isTop).then((res) => {
      this.submitFn()
    })
  }

  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      },
    })
  }

  copyProduct(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `确定要复制商品吗?`,
      onOk: () => {
        GoodsApi.copyProduct(row.id).then((res) => {
          //刷新列表
          this.$Message.success('复制成功')
          this.submitFn()
        })
      },
    })
  }

  handleDelete(id: string | number) {
    GoodsApi.deleteById(id).then((res) => {
      this.submitFn()
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll(selection) {
    this.isCheckAll = true
    if (selection.length === 0) {
      var data = (this.$refs.selection as any).data
      data.forEach((item) => {
        if (this.selectedIds.includes(item.id)) {
          const index = this.selectedIds.findIndex((item1) => {
            return item1.id === item.id
          })
          this.selectedIds.splice(index, 1)
        }
      })
    } else {
      selection.forEach((item) => {
        this.selectedIds.push(item.id)
      })
    }
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
    console.log('选择的数据', (this.$refs.selection as any).data, selection)
  }
  handleSelect(slection, row) {
    this.selectedIds.push(row.id)
    // console.log(slection, row)
  }
  handleCancel(slection, row) {
    const index = this.selectedIds.findIndex((item) => {
      return item.id === row.id
    })
    this.selectedIds.splice(index, 1)
    // console.log(slection, row)
  }

  handleSelectAll() {
    if (!this.tableData.length) return
      ; (this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
  sortChange(e) {
    console.log(e);
    this.sorting = e.order == 'normal' ? 'creationTime desc' : `code ${e.order}`
    this.submitFn()
  }

  /**
   * 批量上/下架
   */
  publishedChangeAll(state: boolean) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      // console.log('批量上/下架', state)
      let ids = selection.map((item) => {
        return item.id
      })
      GoodsApi.updatePublished(ids, state).then((res) => {
        this.submitFn()
      })
    } else {
      this.$Notice.warning({
        title: '请先选择商品',
      })
    }
  }
  tasks: any[] = []
  matchPicture() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.tasks = selection.map((item) => {
        return {
          id: item.id,
          code: item.code,
          status: '待匹配',
          remark: '',
        }
      })
      this.matchPicturesModal = true
    } else {
      this.$Notice.warning({
        title: '请先选择商品',
      })
    }
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除商品规格',
        content: `是否删除已选中的商品规格?`,
        onOk: () => {
          console.log('点了确定了')
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择商品',
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
    let _that = this
    setTimeout(function () {
      //拿到当前table的所有行的引用，里面包含_isChecked属性
      var objData = ((_that.$refs.selection as any).$refs as any).tbody.objData
      console.log(objData)
      for (let key in objData) {
        if (_that.selectedIds.includes(objData[key].id)) {
          objData[key]._isChecked = true
        }
      }
    }, 0)
    console.log(this.selectedIds)
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
  importProduct() {
    this.$router.push({ name: 'importProduct' })
  }
  batchEdit() {
    this.batchEditProductModal = true
  }
  /**
   * 批量定时上架
   */
  handleBatchShelf(formValidate) {
    // console.log('批量定时上/下架')
    let selection = (this.$refs.selection as any).getSelection()
    let ids = selection.map((item) => {
      return item.id
    })
    GoodsApi.batchShelf(ids, formValidate.beginTime, formValidate.endTime).then((res) => {
      this.submitFn()
      this.batchShelfmodal = false
    })
  }
  batchShelf() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.batchShelfmodal = true
    } else {
      this.$Notice.warning({
        title: '请先选择商品',
      })
    }
  }
  syncProduct() {
    this.syncProductModal = true
    // let selection = (this.$refs.selection as any).getSelection()
    // if (selection.length) {
    //   let arr = selection.map(item => item.code)
    //   GoodsApi.updateStock(arr).then((res) => {
    //     this.$Notice.success({
    //       title: '同步成功',
    //     })
    //     this.submitFn()
    //   })
    // } else {
    //   this.$Notice.warning({
    //     title: '请先选择商品',
    //   })
    // }
  }
  syncProductStock() {
    this.loading = true
    GoodsApi.syncAllProductStock().then(res => {
      this.loading = false
      this.$Notice.success({
        title: '同步成功'
      })
      this.submitFn()
    }).catch(err => {
      this.loading = false
    })
  }
  /**
   * 导出订单报表
   */
  exportExcel() {
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let keyWord = form['keyWord']
    let checkStatus = form['checkStatus']
    let selection = (this.$refs.selection as any).getSelection()
    let ids = selection.map((item) => {
      return item.id
    })
    let categoryId = [form['categoryId']]
    let brandId = [form['brandId']]
    GoodsApi.exportExcel(this.pageSize, this.currentPage, keyWord, ids, categoryId, brandId)
      .then((res) => {
        this.download(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '商品信息列表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  /**
   * 获取商品标签
   */
  async getGoodTag() {
    await GoodsApi.getGoodTag(900, 0).then((res) => {
      if (res.data.items) {
        this.tagList = res.data.items
      }
    })
  }
}
